import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

function getAll(params = {}) {
  return AuthAxios.get(`${DataApiUrl}/admin/reportFiles`, { params })
    .then(res => res?.data?.data)
    .catch(err => {
      throw err.response;
    });
}

function patchFileStatusToPending(id) {
  return AuthAxios.patch(`${DataApiUrl}/admin/reportFiles/${id}/patch-file-status-to-pending`).then(
    res => res?.data?.data
  );
}

function getDspOptions() {
  return AuthAxios.get(`${DataApiUrl}/admin/reportFiles/dsp-options`)
    .then(res => res?.data?.options || [])
    .catch(() => {
      return [];
    });
}

const reportFilesApi = { getAll, patchFileStatusToPending, getDspOptions };
export default reportFilesApi;
